
import { useEffect, useRef } from 'react';
import styles from './WishChart.module.css';
import { Chart, registerables } from 'chart.js';
import { explanationIds } from '../../common/authentication/models/user';

Chart.register(...registerables);

const WishChart = ({ currentBuilding }) => {

    const canvasRef = useRef(undefined);
    const chartDrawn = useRef<Chart>(undefined);

    useEffect(() => {
        const getComputedPercentageForType = (type): number => {
            let result = 0;
            let props = currentBuilding.props;
            if (props.totalAmountOfAllUnits) {
                const findType = props.totalAmountOfAllUnits.find(u => u.type === type);
                if (findType && findType.percentage) {
                    result = Math.round(findType.percentage);
                }
            }
            return result;
        }

        const getAmountForType = (type): number => {
            let result = 0;
            let props = currentBuilding.props;
            if (props && props.totalAmountOfAllUnits) {
                const findType = props.totalAmountOfAllUnits.find(u => u.type === type);
                if (findType && findType.amount) {
                    result = findType.amount;
                }
            }
            return result;
        }
        if (canvasRef && currentBuilding && currentBuilding.props && currentBuilding.props.unitWishList) {
            const props = currentBuilding.props;
            const wishedData = props.unitWishList.map(u => u.percentage);
            const resultingData = props.unitWishList.map(u => getComputedPercentageForType(u.type));
            const labels = props.unitWishList.map(u => { return u.type + ' - ' + getAmountForType(u.type) });
            const types = props.unitWishList.map(u => u.type);
            if (canvasRef.current) {
                const data = {
                    labels,
                    datasets: [
                        {
                            label: 'Resultaat',
                            data: resultingData,
                            backgroundColor: types.map(t => {
                                let color = 'rgba(255, 255, 255, 1)';
                                switch (t) {
                                    case 'C-XS':
                                        color = 'rgba(251, 169, 25, 1)';
                                        break;
                                    case 'C-S':
                                        color = 'rgba(242, 237, 116, 1)';
                                        break;
                                    case 'C-M':
                                        color = 'rgba(113, 185, 216, 1)';
                                        break;
                                    case 'C-L':
                                        color = 'rgba(230, 111, 106, 1)';
                                        break;
                                    case 'C-XL':
                                        color = 'rgba(136, 129, 189, 1)';
                                        break;
                                    case 'G-S':
                                        color = 'rgba(242, 237, 116, 1)';
                                        break;
                                    case 'G-M':
                                        color = 'rgba(113, 185, 216, 1)';
                                        break;
                                    case 'G-L':
                                        color = 'rgba(230, 111, 106, 1)';
                                        break;
                                    case 'G-XL':
                                        color = 'rgba(169, 90, 113, 1)';
                                        break;
                                    case 'H-S':
                                        color = 'rgba(248, 193, 58, 1)';
                                        break;
                                    case 'H-M':
                                        color = 'rgba(136, 129, 189, 1)';
                                        break;
                                    case 'H-L':
                                        color = 'rgba(68, 116, 141, 1)';
                                        break;
                                    default:
                                        break;
                                }
                                return color;
                            }).filter(s => s !== undefined),
                            barPercentage: 0.5
                        },
                        {
                            label: 'Wens',
                            data: wishedData,
                            backgroundColor: 'rgb(188, 210, 255)'
                        }
                    ]
                };
                if (chartDrawn && chartDrawn.current) {
                    chartDrawn.current.data = data;
                    chartDrawn.current.update();
                } else {
                    chartDrawn.current = (new Chart(canvasRef.current as any, {
                        type: 'bar',
                        data,
                        options: {
                            responsive: true,
                            animation: {
                                duration: 0
                            },
                            scales: {
                                y: {
                                    beginAtZero: true,
                                },
                                x: {
                                    stacked: true,
                                },
                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: (item) => `${item.formattedValue}%`,
                                    },
                                }
                            }
                        }
                    })
                    );
                }
            }
        }
    }, [canvasRef, currentBuilding, chartDrawn])

    return (
        <div data-explanation-id={explanationIds.buildingDetails} className={styles.WishChart} data-testid="WishChart">
            <canvas ref={canvasRef} id={'svgId' + currentBuilding.id} width="400" height="400"></canvas>
        </div>
    )
};

export default WishChart;
